import React, { useEffect, useState, useCallback } from "react";
import { API } from "../../config/api";
import "./../Styles/AddHiring.css";

export default function AddHiring() {
  const loginUser = JSON.parse(sessionStorage.getItem("user") || "{}");

  const [loading, setLoading] = useState(false);
  const [listLoading, setListLoading] = useState(true);
  const [hiringList, setHiringList] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    details: "",
    address: "",
    mobile: loginUser?.phone || "",
  });

  const [errors, setErrors] = useState({});

  const fetchHiring = useCallback(async () => {
    try {
      setListLoading(true);

      if (!loginUser?.id) {
        console.log("User not logged in");
        return;
      }

      const res = await fetch(`${API.GET_HIRING}&user_id=${loginUser.id}`);
      const data = await res.json();

      if (data.success) {
        setHiringList(data.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setListLoading(false);
    }
  }, [loginUser?.id]);
  useEffect(() => {
    fetchHiring();
  }, [fetchHiring]);
  const validate = () => {
    const err = {};
    if (!formData.name.trim()) err.name = "Name is required";
    if (!formData.details.trim()) err.details = "Hiring details required";
    if (!formData.address.trim()) err.address = "Address required";
    if (!formData.mobile.trim()) err.mobile = "Mobile number required";
    else if (!/^[6-9]\d{9}$/.test(formData.mobile))
      err.mobile = "Enter valid mobile number";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setFormData({
      name: "",
      details: "",
      address: "",
      mobile: loginUser?.phone || "",
    });
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    try {
      const form = new FormData();
      form.append("user_id", loginUser.id);
      form.append("name", formData.name);
      form.append("details", formData.details);
      form.append("address", formData.address);
      form.append("mobile", formData.mobile);

      if (editingId) {
        form.append("id", editingId);
      }

      let url = editingId ? API.UPDATE_HIRING : API.ADD_HIRING;
      const res = await fetch(url, {
        method: "POST",
        body: form,
      });

      const data = await res.json();
      if (data.success) {
        alert(data.message);
        resetForm();
        fetchHiring();
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.log(err);
      alert("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const editHiring = (item) => {
    setEditingId(item.id);
    setFormData({
      name: item.name,
      details: item.details,
      address: item.address,
      mobile: item.mobile,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const deleteHiring = async (id) => {
    if (!window.confirm("Delete this hiring advertisement?")) return;
    try {
      const form = new FormData();
      form.append("id", id);
      const res = await fetch(API.DELETE_HIRING, {
        method: "POST",
        body: form,
      });
      const data = await res.json();
      if (data.success) {
        fetchHiring();
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="hiring-container">
      <div className="hiring-sidebar">
        <div className="hiring-form-box">
          <h2>{editingId ? "Update Advertisement" : "Create Advertisement"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                {" "}
                <div className="form-group">
                  <label>Name </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {errors.name && (
                    <span className="error-text">{errors.name}</span>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                {" "}
                <div className="form-group">
                  <label>Mobile Number</label>
                  <input
                    type="text"
                    maxLength="10"
                    name="mobile"
                    placeholder="10-digit mobile number"
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                  {errors.mobile && (
                    <span className="error-text">{errors.mobile}</span>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                {" "}
                <div className="form-group">
                  <label>Address</label>
                  <textarea
                    rows="1"
                    name="address"
                    placeholder="Complete work address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                  {errors.address && (
                    <span className="error-text">{errors.address}</span>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Hiring Details</label>
                  <textarea
                    rows="1"
                    name="details"
                    placeholder="Describe experience, salary, timings, etc."
                    value={formData.details}
                    onChange={handleChange}
                  />
                  {errors.details && (
                    <span className="error-text">{errors.details}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-actions-row mt-0">
              <button type="submit" className="submit-btn" disabled={loading}>
                {loading
                  ? "Please Wait..."
                  : editingId
                    ? "Save Changes"
                    : "Submit"}
              </button>
              {editingId && (
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={resetForm}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>
      </div>

      <div className="hiring-main-content">
        <h2 className="section-title">Hiring Details</h2>
        {listLoading ? (
          <div className="state-box loading">
            <div className="spinner"></div>
            <p>Fetching your listings...</p>
          </div>
        ) : hiringList.length === 0 ? (
          <div className="state-box empty">
            <i className="bi bi-folder-x"></i>
            <p>No active hiring campaigns found.</p>
          </div>
        ) : (
          <div className="hiring-list">
            {hiringList.map((item) => (
              <div className="hiring-card-horizontal" key={item.id}>
                <div className="hiring-top">
                  <div className="hiring-user-info">
                    <div className="hiring-name">
                      <i className="bi bi-person-workspace me-2"></i>
                      <strong>{item.name}</strong>
                    </div>

                    <div className="hiring-mobile">
                      <i className="bi bi-telephone-fill me-2"></i>
                      {item.mobile}
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-3">
                    <span
                      className={`status-badge ${
                        item.status === "Active"
                          ? "active"
                          : item.status === "Rejected"
                            ? "rejected"
                            : "pending"
                      }`}
                      style={{
                        backgroundColor:
                          item.status === "Active"
                            ? "#198754"
                            : item.status === "Hide"
                              ? "#dc3545"
                              : "#e9872b",
                        color: "#fff",
                        padding: "6px 14px",
                        borderRadius: "30px",
                        fontWeight: "600",
                        fontSize: "13px",
                        minWidth: "90px",
                        textAlign: "center",
                      }}
                    >
                      {item.status}
                    </span>

                    {item.created_at && (
                      <div className="hiring-date">
                        <i className="bi bi-calendar-event me-1"></i>
                        {new Date(item.created_at).toLocaleDateString(
                          undefined,
                          {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          },
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Address */}
                <div className="hiring-address">
                  <strong>Address :</strong> {item.address}
                </div>

                {/* Details */}
                <div className="hiring-details">
                  <strong>Details :</strong> {item.details}
                </div>

                {/* Footer */}
                <div className="card-footer justify-content-end">
                  <button
                    className="action-btn edit"
                    onClick={() => editHiring(item)}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  <button
                    className="action-btn delete"
                    onClick={() => deleteHiring(item.id)}
                  >
                    <i className="bi bi-trash3"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
